import { Offer } from "@api-types/account-settings/Offer";
import { FilterEventId } from "@data-types/account-statement/FilterEventId";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ContextOptions, ApiRequestContextData } from "@utils/api-config/types";

export class OfferService {
	static baseUrl(config: ApiRequestContextData): string {
		return `${WEBPACK_BASE_PROXY_ADDRESS}${config?.agencyKey}/offer`;
	}

	static getRequestHeaders = (context: ApiRequestContextData) => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async findOffer(
		eventIds: FilterEventId,
		options: ContextOptions
	): Promise<Offer> {
		const context = getApiRequestContext(options);
		return await httpClient.post(
			`${this.baseUrl(context)}`,
			JSON.stringify(eventIds),
			this.getRequestHeaders(context)
		);
	}
}
